export const motorisedRollerBlinds = {
  overview: {
    titles: [
      "Style and Functionality",
      "Privacy",
      "Convenience",
      "Versatility",
    ],
    contents: [
      "Motorised roller blinds are the ultimate in luxury, sophistication, and convenience. They look fantastic, there are no wires or complex installations, and you have complete control over their operation using a remote, a hub device, or your voice.",
      "Certain materials such as block out roller blinds give you total privacy right when you need it.",
      "Motorised roller blinds are the most convenient and easiest to operate option that you can choose. Operation is via a remote, with a quiet and carefully concealed motor doing the job of either opening or closing your blinds. Opening and closing can even be automated.",
      "Roller blinds are flexible – they can cover multiple windows or individual large ones. They can be synchronised, separated or even operated in sequence. For motorised roller blinds, they can be operated by rechargeable battery or mains power. Either way, they are easy to manage.",
    ],
  },
  description: {
    titles: ["", ""],
    contents: [
      "Motorised roller blinds are the ultimate in luxury, sophistication, and convenience. They look fantastic, there are no wires or complex installations, and you have complete control over their operation using a remote, a hub device, or your voice.",
      "The motors for our motorised blinds are installed in the tube of the blind, so they are completely invisible. They also don’t require any additional clearance. As a result, all the roller blinds in our range can be motorised, whether you want blackout blinds, thermal blinds, sunscreen blinds, light filtering blinds, or dual roller blinds.",
      "In addition, our motorised blinds don’t need to be connected to your electrics, and there are no wires. Instead, they are powered by battery. The recharging options are either solar or via a USB cable. The blinds take about eight hours to charge, but a single charge can open/close your blinds up to 500 times.",
    ],
  },
  summary: {
    header:
      "Simple and stylish, roller blinds are our most popular product. They’re easy to operate and maintain, and come in a number of colour ways and fabrics.",
    subItems: [
      {
        title: "BLOCKOUT ROLLER BLINDS",
        details:
          "Prevent sun light from entering any room with the specifically engineered blackout roller blinds. They’re great for optimum sleep or privacy. And parents swear by then for establishing the right sleep patterns in small children. We offer thermal blockout options to regulate heat in a room so you’re cozy in winter or cool in summer.",
      },
      {
        title: "SUNSCREEN ROLLER BLINDS",
        details:
          "Sunscreen roller blinds have a dual benefit. They cut out sunlight for glare control and provide shade to protect furnishings from harmful UV. Because they are semi-transparent you can also maintain your view while achieving privacy and light control. Available in either 3%, 5% of 10% screen, simply choose the best option for your needs.",
      },
      {
        title: "COMBINATION ROLLER BLINDS",
        details:
          "Consider combining blockout and sunscreen roller blinds on the same window to achieve the best of both worlds – complete darkness when you need it and a glare-protected view during the day.",
      },
      {
        title: "MOTORISED FOR EASE",
        details:
          "Window Answers’ roller blinds can be motorised for ease. This is a great solution if you have a large area of blinds or blinds which are difficult to access.",
      },
    ],
  },
  about: {
    header: "What we say about Roller blinds",
    col01: {
      title: "Great for…",
      items: [
        "Reducing light in bedrooms with blackout fabrics",
        "Kitchens and bathrooms with water resistant finishes",
        "Hard to reach windows or multiple blinds with motorised options",
        "Perfect Fit frames, giving a streamlined finish",
        "Skylight windows",
      ],
    },
    col02: {
      title: "Things to consider",
      items: [
        "Roller blinds are made from one piece of fabric, so they can’t be shaped around sloping or unusual windows",
        "All our Roller blinds are chain or pull-cord operated, and our advisors will fit child safety cleats as standard. Alternatively, Perfect Fit or motorised Roller blinds are cordless",
        "For a drill-free option, choose Perfect Fit blinds, which clip into your uPVC frames",
      ],
    },
  },
};
